module.exports = __webpack_public_path__ + "static/media/javascript sass html jquery.c45fb54e.pdf";